import { useState } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff"
import { MONO, CHAT_COLOR } from "../constants"
import { scrollbarSx } from "../../../shared/scrollbar"
import { GroupImagePicker } from "./GroupImagePicker"
import { MemberPicker } from "./MemberPicker"

export function GroupSettingsPanel({ group, users, me, muted, onSave, onToggleMute, onClose }) {
  const [name, setName] = useState(group.name)
  const [image, setImage] = useState(group.image || "")
  const [members, setMembers] = useState(new Set(group.members || []))
  const toggle = (u) => setMembers(prev => { const n = new Set(prev); n.has(u) ? n.delete(u) : n.add(u); return n })
  return (
    <Box sx={{ flex: 1, overflowY: "auto", p: 1.5, ...scrollbarSx }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Typography sx={{ color: CHAT_COLOR, fontFamily: MONO, fontSize: "0.7rem", fontWeight: 600, flex: 1 }}>
          Group settings
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ p: 0, color: "rgba(var(--app-fg-rgb),0.4)" }}>
          <CloseIcon sx={{ fontSize: 13 }} />
        </IconButton>
      </Box>
      <GroupImagePicker image={image} onPick={setImage} label="Change image" />
      <TextField value={name} onChange={(e) => setName(e.target.value)} placeholder="Group name"
        size="small" fullWidth
        sx={{ mb: 1.25, "& .MuiInputBase-input": { fontFamily: MONO, fontSize: "0.72rem", color: "#fff" },
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(var(--app-fg-rgb),0.12)" } }} />
      <Box onClick={() => onToggleMute(group.group_id)}
        sx={{ display: "flex", alignItems: "center", gap: 1, px: 1.25, py: 0.7, mb: 1.25, borderRadius: 1, cursor: "pointer",
          backgroundColor: "rgba(var(--app-fg-rgb),0.03)", border: "1px solid rgba(var(--app-fg-rgb),0.06)" }}>
        <NotificationsOffIcon sx={{ fontSize: 14, color: muted ? "var(--app-error)" : "rgba(var(--app-fg-rgb),0.4)" }} />
        <Typography sx={{ flex: 1, fontFamily: MONO, fontSize: "0.68rem", color: "rgba(var(--app-fg-rgb),0.7)" }}>
          Notifications
        </Typography>
        <Typography sx={{ fontFamily: MONO, fontSize: "0.66rem", color: muted ? "var(--app-error)" : "var(--app-success)" }}>
          {muted ? "Off" : "On"}
        </Typography>
      </Box>
      <Typography sx={{ color: "rgba(var(--app-fg-rgb),0.35)", fontFamily: MONO, fontSize: "0.62rem", mb: 0.75 }}>
        Members
      </Typography>
      <MemberPicker users={users} me={me} selected={members} onToggle={toggle} />
      <Box onClick={() => onSave(group.group_id, { name: name.trim() || group.name, image, members: [...new Set([me, ...members])] })}
        sx={{ textAlign: "center", py: 0.7, mt: 1.5, borderRadius: 1, cursor: "pointer",
          fontFamily: MONO, fontSize: "0.7rem", backgroundColor: "rgba(245,158,11,0.15)",
          color: CHAT_COLOR, border: "1px solid rgba(245,158,11,0.3)" }}>
        Save changes
      </Box>
    </Box>
  )
}
